import React, { CSSProperties } from "react";

const MinusIcon = ({ scale, color, style }: { scale?: number; color?: string; style?: CSSProperties }) => {
  let c = "#1062D0";
  if (color) c = color;
  return (
    <svg
      width="18"
      height="2"
      viewBox="0 0 18 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${scale || 1})` }}
    >
      <path d="M16.4998 1H1.49976" stroke={c} strokeWidth="2" stroke-linecap="round" />
    </svg>
  );
};

export default MinusIcon;
